import { call, select } from 'core/middlewares/utilities';

import { bffInit } from './bff-init';
import { getters } from './getters';

import type { RootState } from 'core/store';

/**
 * Redirects user to homepage route entry
 *
 */
export function* redirectLogin() {
  const { isPrivate } = yield call(getters.getRouteConfig);
  const { isBlocked }: getters.UserState = yield call(getters.getUser);
  const isResaleIntention: RootState['user']['data']['isResaleIntention'] = yield select(
    (rootState: RootState) => rootState.user.data.isResaleIntention,
  );

  const isAutoStartEnabled: RootState['user']['data']['isAutoStartEnabled'] = yield select(
    (rootState: RootState) => rootState.user.data.isAutoStartEnabled,
  );

  const irCanBuy = !isResaleIntention || (isResaleIntention && isAutoStartEnabled);

  if (isPrivate && !isBlocked && irCanBuy) {
    yield bffInit();
  }
}
